// extracted by css-extract-rspack-plugin
export default {"cls1":"TagSelector-cls1_ZLA","cls2":"TagSelector-cls2_THy TagSelector-cls1_ZLA"};